<template>
	<vx-modal :title="$t('MODALS.movePage.title')" :width="width">
	    <template v-slot:body>
	    	<div v-if="message.length > 0" class="p-3" v-html="message">	    		
	    	</div>
	        <div v-else  class="flex justify-between p-3">
	        	<div class="pages w-1/2 px-1">
	        		<div class="title-move bg-primary p-2 text-white font-bold">
	                     <feather-icon class="" icon="FileTextIcon" svgClasses="h-5 w-5" />
	                     <span class="ml-3">{{$t('MODALS.movePage.pages')}}</span>                    
	                </div>
	                <div class="all-pages-move w-full">	                	
	                    <ul class="list-pages-move">
	                        <li class="cursor-pointer flex" v-for="({key, questions}, index) in allPages" :key="index" @click="setVariables(key, questions, index)">
	                            <div style="width: 30px;">
	                                <feather-icon  icon="ChevronRightIcon" svgClasses="h-5 w-5" v-if="keyPageCurrent === key"/>
	                            </div>
	                            
	                            <span>
	                                {{$t('MODALS.movePage.page')}} {{index + 1}}                                                                                     
	                            </span>
	                            
	                        </li>                        
	                    </ul>
	                </div>
	        	</div>
	        	<div class="questions w-1/2 px-1">
	        		<label>{{$t('MODALS.movePage.positionQuestion')}}</label>
	        		<v-select class="w-full" v-model="selected" :options="options" :dir="$vs.rtl ? 'rtl' : 'ltr'" />	        		
	        		<div class="all-pages-move w-full mt-2">
	        			<ul class="list-question">
	        				<li class="cursor-pointer flex items-center" v-for="(question, index) in questions" :key="index" @click="questionCurrent = question.name">
	        					<div style="width: 30px;" >
	        					    <feather-icon  icon="ChevronRightIcon" svgClasses="h-5 w-5" v-if="questionCurrent === question.name"/>
	        					</div>
	        					<div>
	        						{{question.name}}
	        						<span class="block truncate" :style="styleW">{{question.label}}</span>
	        					</div>
	        					
	        				</li>
	        			</ul>
	        		</div>
	        		
	        		<button  class="p-3 mt-4 w-4/5 bg-primary  border-0 text-white font-bold flex m-auto justify-center items-center" :class="{'bg-disabled': !disabledBtnByoption, 'cursor-pointer': disabledBtnByoption}" @click="disabledBtnByoption?moveQuestion():null">
	        		    <feather-icon class="" icon="CheckIcon" svgClasses="h-5 w-5" />
	        		    <span class="ml-3">{{$t('MODALS.movePage.move')}}</span>
	        		</button>
	        	</div>
	        </div>
	        
	    </template>
	</vx-modal>
	
</template>

<script type="text/javascript">
	import vSelect from 'vue-select';
	import { 
		getAllPages, setQuestion, 
		updatePages, getDependencies, 
		getAllQuestion } from "@/serviforms/designer/indexDB/logic.js";
	import  { updateDependecies } from '@/serviforms/designer/indexDB/dependencies.js';

	import { mapState, mapMutations } from 'vuex';

	export default {
		components: { 'v-select': vSelect },
		async mounted() {
			await setQuestion();
			const hasDependence = await this.validateDependence();
			const result = await getAllPages();
			this.allPages = result.map(page => {
				return {
					key: page.key,
					questions: page.questions.filter(question => question.name !== this.question.name)
				}
			});
			const filterQuestion = this.allPages.find(page => page.key === this.idPage);			
			this.keyPageCurrent = this.idPage;
			if(filterQuestion.questions.length > 0)	{
				this.questionCurrent = filterQuestion.questions[0].name;
				this.questions = filterQuestion.questions;
			}else {
				this.questionCurrent = '';
				this.questions = [];
			}
			
		},		
		data() {
			return {
				message: '',
				keyPageCurrent: '',
				questionCurrent: '',
				questions: [],
				allPages: [],
				styleW: {width: '100px'},
				selected: {id: 1, label: this.$t('MODALS.movePage.toInit')},
				options: [
					{id: 1, label: this.$t('MODALS.movePage.toInit')},
					{id: 2, label: this.$t('MODALS.movePage.after')},
					{id: 3, label: this.$t('MODALS.movePage.before')},
					{id: 4, label: this.$t('MODALS.movePage.toFinal')},
				]
			}
		},
		methods: {
			...mapMutations('resource', ['DELETE_QUESTION', 'UPDATE_STATE', 'UPDATE_STATE']),
			setVariables(key, questions, index) {				
				this.keyPageCurrent = key; 
				this.questions = questions;
				this.pageSelected = index;
				if(this.questions.length > 0) this.questionCurrent = this.questions[0].name;
				else this.questionCurrent = '';
			},
			moveQuestion() {
				const option = this.selected.id;
				this.moveToInitEnd(option);				
			},
			async moveToInitEnd(option) {				
				const keyPage = this.keyPageCurrent;				
				const question = this.question;
				
				let questionNew = this.allPages.find(page => page.key === keyPage).questions;

				if(option === 1) questionNew.unshift(question);
				else if(option === 4)questionNew.push(question);
				else if(option === 2){
					const nameQuestion = this.questionCurrent;
					const indexMove = this.questions.findIndex(question => question.name === nameQuestion);
					questionNew.splice(indexMove + 1, 0, question);
				}else if(option === 3) {
					const nameQuestion = this.questionCurrent;
					const indexMove = this.questions.findIndex(question => question.name === nameQuestion);
					questionNew.splice(indexMove, 0, question);
				}				
									
				await updatePages(keyPage, questionNew);

				if(this.idPage !== keyPage) {	
					this.DELETE_QUESTION(this.indexQuestion);		
					await setQuestion();
				} else {					
					this.DELETE_QUESTION(this.indexQuestion);
					this.UPDATE_STATE({key: 'questionsByPage', value: questionNew});					
				}				
				this.UPDATE_STATE({key: 'activePopup', value: false});
				setTimeout(() => this.UPDATE_STATE({key: 'componentPopup', value: ''}), 50);
				const allPages = await getAllPages();
				this.UPDATE_STATE({key: 'allPages', value: allPages});

				this.reorganizarIndex();
			},
			async validateDependence() {
				this.message = '';
				const { dependencias, simple, compound, listener } = await getDependencies();
				
				if(simple[this.question.name]) {
					this.message = `La pregunta con ID <b>${this.question.name}</b> contiene dependencias, debe desvincular sus dependencias para realizar esta acción.`;
				}

				const IntoDependencies = async () => {
					let Dad = null;
					for(var i in simple) {
						if(simple[i][this.question.name]) {
							Dad = i;
							break;
						}
					}
					return Dad;
				}

				let result = await IntoDependencies();
				if(result) {
					return this.message = `La pregunta con ID <b>${this.question.name}</b> depende de la pregunta con ID <b>${result}</b>, desvinculela de la pregunta <b>${result}</b> para realizar esta acción.`
				}

				if(compound[this.question.name]) {
					return this.message = `La pregunta con ID <b>${this.question.name}</b> contiene dependencias compuestas, debe desvincular sus dependencias para realizar esta acción.`;
				}

				const IntoCompound = async () =>  {
					let Dad = null;
					for(var i in compound) {
						const result = compound[i].answers.find(answer => answer.name === this.question.name);
						if(result) {
							Dad = i;
							break;
						}
					}
					return Dad;
				}

				result = await IntoCompound();

				if(result) {
					return this.message = `La pregunta con ID <b>${this.question.name}</b> hace parte de una dependencia compuesta cuyo padre es la pregunta con ID <b>${result}</b>, debe desvincularla para realizar esta acción.`;
				}

				if(listener[this.question.name]) {
					return this.message = `La pregunta con ID <b>${this.question.name}</b> contiene dependencias listener, debe desvincular sus dependencias para realizar esta acción.`;
				}

				const IntoListener = async () => {
					let Dad = null;
					for(var i in listener) {
						const result = listener[i].related.name;
						if(result === this.question.name) {
							Dad = i;
							break;
						}
					}
					return Dad;
				}

				result = await IntoListener();

				if(result) {
					return this.message = `La pregunta con ID <b>${this.question.name}</b> hace parte de una dependencia listenerr cuyo padre es la pregunta con ID <b>${result}</b>, debe desvincularla para realizar esta acción.`;
				}
			},
			async reorganizarIndex() {			
				const { compound, simple, listener } = await getDependencies();
				const newCreated = await this.reorganizateCreate(simple);
				await setQuestion();
				const newCompound = await this.reorganizateCompound(compound);
				await setQuestion();
				const newListener = await this.reorganizateListener(listener);
				updateDependecies(newCreated, newCompound, newListener);
			},
			async creteIndex() {
				const result = await getAllQuestion();
				let object = {};
				for(var i in result) object[result[i].name] = parseInt(i);
				return object;			
			},
			async reorganizateCreate(create) {	
				const listIndex = await this.creteIndex();			
				for(var i in create) {				
					for(var j in create[i]) {
						create[i][j].question = listIndex[create[i][j].name];
					}
				}
				return create;
			},
			async reorganizateCompound(compound) {			
				let listIndex = await this.creteIndex();
				for(var i in compound) {
					for(var j in compound[i].answers){
						compound[i]['answers'][j].question = listIndex[compound[i]['answers'][j].name]
					}
				}
				return compound;
			},
			async reorganizateListener(listener) {
				const listIndex = await this.creteIndex();				
				for(var i in listener) {								
					listener[i].related.question = listIndex[listener[i].related.name];
				}
				return listener;
			},
		},
		computed: {
			...mapState('resource', ['questionsByPage', 'indexQuestion', 'idPage', 'activePopup']),
			windowWidth() { return this.$store.state.windowWidth; },
			width() {

		        if (this.windowWidth > 1400) {
		        	this.styleW = {width: '220px'};
                   return '40%';		            
		        } else if (this.windowWidth > 1200) {
		        	this.styleW = {width: '250px'};
                   return '50%';
		        } else if (this.windowWidth > 800) {
		        	this.styleW = {width: '250px'};
		        	return '70%';
		        }  else {
		        	this.styleW = {width: '190px'};
		        	return '70%';
		        }           
            },
            question() {
            	return this.questionsByPage[this.indexQuestion];
            },
            disabledBtn() {
            	const condition1 = this.keyPageCurrent.length > 0;
            	const condition2 = this.questionCurrent.length > 0;
            	const condition3 = (this.selected !== null && this.selected !== undefined && this.selected !== '');      	

            	return (condition1 && condition2 && condition3)
            },
            disabledBtnByoption() {
            	if(this.selected === null) return false;
            	if(this.selected.id !== 1 && this.selected.id !== 4) {            		
            		return this.disabledBtn;
            	}

            	return true;
            }
		}
	}
</script>



<style lang="scss" scoped>
	.bg-disabled {
		opacity: 0.65;
		cursor: not-allowed;
	}

	.height-card {
	    min-height: 400px;
	}

	.list-pages-move {
	    max-height: 300px;
	    overflow: auto;
	}

	.list-question {
		max-height: 220px;
		overflow: auto;
	}

	.list-pages-move > li, .list-question > li {
	     padding: 10px;     
	}
	.list-pages-move > li:nth-child(2n), .list-question > li:nth-child(2n) {
	   background: #E6E6E6;
	}
	.list-pages-move > li:nth-child(2n + 1),  .list-question > li:nth-child(2n + 1){
	   background: #F2F2F2;
	}
</style>